import { GET_LIST } from "../../types/ActionTypes";
import { HistoryAndIllnessResponse } from "./Model";

// Patient Demographics Loading State
export const HISTORY_AND_ILLNESS_LOADING = "HISTORY_AND_ILLNESS_LOADING";
export const HISTORY_AND_ILLNESS_SUCCESS = "HISTORY_AND_ILLNESS_SUCCESS";
export const HISTORY_AND_ILLNESS_FAIL = "HISTORY_AND_ILLNESS_FAIL";

export interface GetPatientDemographicsState {
  historyandillnessDetails: HistoryAndIllnessResponse;
  loading: boolean;
}
export interface DoctorListLoading {
  type: typeof HISTORY_AND_ILLNESS_LOADING;
}
export interface DoctorListSuccess {
  type: typeof HISTORY_AND_ILLNESS_SUCCESS;
  payload: HistoryAndIllnessResponse;
}
export interface DoctorListFail {
  type: typeof HISTORY_AND_ILLNESS_FAIL;
}
interface GetDoctorAction {
  type: typeof GET_LIST;
  payload: HistoryAndIllnessResponse;
}

export type HistoryAndIllnessActionTypes =
  | GetDoctorAction
  | DoctorListLoading
  | DoctorListSuccess
  | DoctorListFail;
